<template>
<v-app>
  <div>
    <v-btn color="info" v-on:click="gotoUsers">Usuarios</v-btn>
    <v-btn color="info" v-on:click="gotoNews">Noticias</v-btn>
    <v-btn color="info" v-on:click="gotoComments">Sugerencias</v-btn>
    <v-btn color="info" v-on:click="gotoShops">Locales</v-btn>
    <v-btn color="error" v-on:click="logout">Salir</v-btn>
    <img src="../assets/logo.png" width="100px" style="float: right;">
    <hr style="margin-bottom: 50px;">

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form id="theForm" @submit.prevent="addShop()">
                <div class="title" v-if="!isEdition">Crear Local</div>
                <div class="title" v-if="isEdition">Editar Local</div>

                <v-switch
                    v-model="visible"
                    :label="`Visible`"
                ></v-switch>

                <v-flex>
                    <v-text-field
                        label="Titular *"
                        box
                        v-model="owner"
                        required
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Nombre"
                        box
                        v-model="name"
                    ></v-text-field>
                </v-flex>

                <v-flex d-flex>
                    <v-select
                        :items="sectors"
                        box
                        label="Sector *"
                        v-model="sector"
                    ></v-select>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Local *"
                        box
                        v-model="number"
                        required
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-select
                        :items="shopTypes"
                        item-text="name"
                        item-value="abbr"
                        box
                        chips
                        label="Rubros *"
                        v-model="types"
                        multiple
                    ></v-select>
                </v-flex>

                <div class="subheading">Datos de Contacto</div>
                <v-flex>
                    <v-text-field
                        label="Teléfono"
                        box
                        v-model="phone"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Email"
                        box
                        v-model="email"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Web"
                        box
                        v-model="web"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Facebook"
                        box
                        v-model="fb"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Instagram"
                        box
                        v-model="ig"
                    ></v-text-field>
                </v-flex>

                <div class="subheading">Horarios</div>
                <v-flex><v-text-field label="Lunes" box v-model="open.mon"></v-text-field></v-flex>
                <v-flex><v-text-field label="Martes" box v-model="open.tue"></v-text-field></v-flex>
                <v-flex><v-text-field label="Miércoles" box v-model="open.wed"></v-text-field></v-flex>
                <v-flex><v-text-field label="Jueves" box v-model="open.thu"></v-text-field></v-flex>
                <v-flex><v-text-field label="Viernes" box v-model="open.fri"></v-text-field></v-flex>
                <v-flex><v-text-field label="Sábado" box v-model="open.sat"></v-text-field></v-flex>
                <v-flex><v-text-field label="Domingo" box v-model="open.sun"></v-text-field></v-flex>
                <v-flex><v-text-field label="Feriado" box v-model="open.hol"></v-text-field></v-flex>

                <div class="subheading">Ubicación</div>
                <v-flex><v-text-field label="Latitud" box v-model="lat"></v-text-field></v-flex>
                <v-flex><v-text-field label="Longitud" box v-model="lng"></v-text-field></v-flex>
                <GmapMap
                    :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: false
                    }"
                    :center="{lat: parseFloat(lat), lng: parseFloat(lng)}"
                    :zoom="16"
                    map-type-id="satellite"
                    style="width: 500px; height: 300px"
                    >
                    <GmapMarker
                        ref="mapMarker"
                        :position="{lat: parseFloat(lat), lng: parseFloat(lng)}"
                        :clickable="true"
                        :draggable="true"
                        @dragend="updateMarkerPosition"
                    />
                </GmapMap>

                <div class="subheading" style="margin-top: 20px;">Etiquetas</div>
                <v-combobox
                    v-model="tags"
                    :items="[]"
                    label=""
                    chips
                    clearable
                    box
                    multiple
                >
                    <template v-slot:selection="data">
                    <v-chip
                        :selected="data.selected"
                        close
                        @input="removeTag(data.item)"
                    >
                        <strong>{{ data.item }}</strong>
                    </v-chip>
                    </template>
                </v-combobox>

            </v-form>
          </v-container>
          <small>* indica campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="clearForm()" style="margin-top: 15px;">Cancelar</v-btn>
          <v-btn type="submit" color="primary" form="theForm" style="margin-top: 15px;">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSectorFilter" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form id="theForm2" @submit.prevent="searchSectorRun()">
                <div class="title" style="margin-bottom: 30px;">Filtro por Sector</div>

                <v-flex d-flex>
                    <v-select
                        :items="sectors"
                        box
                        label="Sector"
                        v-model="searchTerms.sector"
                    ></v-select>
                </v-flex>

            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="dialogSectorFilter = false" style="margin-top: 15px;">Cancelar</v-btn>
          <v-btn type="submit" color="primary" form="theForm2" style="margin-top: 15px;">Buscar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVisibilityFilter" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form id="theForm3" @submit.prevent="searchVisibilityRun()">
                <div class="title" style="margin-bottom: 30px;">Filtro por Visibilidad</div>

                <v-flex d-flex>
                    <v-select
                        :items="visibilities"
                        box
                        label="Visibilidad"
                        v-model="searchTerms.visible"
                    ></v-select>
                </v-flex>

            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="dialogSectorFilter = false" style="margin-top: 15px;">Cancelar</v-btn>
          <v-btn type="submit" color="primary" form="theForm3" style="margin-top: 15px;">Buscar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="display-2" style="margin-bottom: 10px;">
        Locales

        <v-btn
            fab
            color="primary"
            right
            absolute
            @click="dialog = !dialog"
            >
            <v-icon>add</v-icon>
        </v-btn>
    </div>

    <table width="100%" style="margin-top: 50px;">
        <thead class="title" style="vertical-align: middle">
            <th style="text-align: left;">Titular
                <v-btn icon @click="searchOwner">
                    <v-icon>search</v-icon>
                </v-btn>
                <div class="caption" v-if="searchTerms.owner != null" style="margin-top: -20px;">
                    (Filtro: "{{searchTerms.owner}}")
                    <v-btn color="error" small icon @click="clearOwnerFilter">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </th>
            <th style="text-align: left;">Nombre
                <v-btn icon @click="searchName">
                    <v-icon>search</v-icon>
                </v-btn>
                <div class="caption" v-if="searchTerms.name != null" style="margin-top: -20px;">
                    (Filtro: "{{searchTerms.name}}")
                    <v-btn color="error" small icon @click="clearNameFilter">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </th>
            <th style="text-align: left;">Sector
                <v-btn icon @click="dialogSectorFilter = true">
                    <v-icon>search</v-icon>
                </v-btn>
                <div class="caption" v-if="searchTerms.sector != null" style="margin-top: -20px;">
                    (Filtro: "{{searchTerms.sector}}")
                    <v-btn color="error" small icon @click="clearSectorFilter">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </th>
            <th style="text-align: left;">Local
                <v-btn icon @click="searchNumber">
                    <v-icon>search</v-icon>
                </v-btn>
                <div class="caption" v-if="searchTerms.number != null" style="margin-top: -20px;">
                    (Filtro: "{{searchTerms.number}}")
                    <v-btn color="error" small icon @click="clearNumberFilter">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </th>
            <th style="text-align: left;">Estado
                <v-btn icon @click="dialogVisibilityFilter = true">
                    <v-icon>search</v-icon>
                </v-btn>
                <div class="caption" v-if="searchTerms.visible != null" style="margin-top: -20px;">
                    (Filtro: "{{searchTerms.visible}}")
                    <v-btn color="error" small icon @click="clearVisibilityFilter">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </th>
            <th style="text-align: right;">Acciones</th>
        </thead>
        <tr v-for="(shop, idx) in shops" :key="idx">
            <td style="text-align: left;">{{ shop.owner }}</td>
            <td style="text-align: left;">{{ shop.name }}</td>
            <td style="text-align: left;">{{ shop.sector }}</td>
            <td style="text-align: left;">{{ shop.number }}</td>
            <td style="text-align: left;">{{ shop.visible ? 'Visible' : 'Oculto' }}</td>
            <td style="text-align: right;">
                <v-btn fab small color="primary" @click="startItemEdit(shop.id)">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn fab small color="error" @click="deleteShop(shop.id)">
                    <v-icon>delete</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td style="text-align: left;"></td>
            <td style="text-align: right;" colspan="5">
                <v-btn color="success" @click="getShops()">
                    Cargar mas items
                    <v-icon right>cloud_download</v-icon>
                </v-btn>
            </td>
        </tr>
    </table>
  </div>
</v-app>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import firebase from 'firebase'
import { db } from '../main'

export default {
    name: 'Comments',
    data () {
        return {
            dialog: false,
            dialogSectorFilter: false,
            dialogVisibilityFilter: false,
            searchTerms: {
                owner: null,
                name: null,
                sector: null,
                number: null,
                visible: null,
            },
            shops: [],
            isEdition: false,
            itemID: '',
            owner: '',
            name: '',
            sector: '',
            visible: false,
            number: '',
            phone: '',
            email: '',
            web: '',
            fb: '',
            ig: '',
            open: {
                mon: '',
                tue: '',
                wed: '',
                thu: '',
                fri: '',
                sat: '',
                sun: '',
                hol: '',
            },
            lat: '-34.4199',
            lng: '-58.5730',
            reportedCenter: {},
            types: [],
            tags: [],
            lastListDoc: null,
            loaderPrefs: {
                'container': null,
                'canCancel': false,
                'color': '#0000FF',
                'background-color': '#FFCC99',
            },
            sectors: [
                'Calle Los Ceibos',
                'Calle Los Eucaliptus',
                'Calle Los Mimbres',
                'Calle Sarmiento',
                'Casuarinas Medio',
                'Casuarinas Peatonal',
                'Embarcaciones de Excursión',
                'Feria Plaza Central',
                'Food Truck',
                'Galería Amarilla',
                'Galería Artífice',
                'Galería Frutos Center',
                'Galería Mercados del Delta',
                'Galería Paseo del Puerto',
                'Galería Paseo Nuevo Puerto',
                'Galería Playland',
                'Galería Portal del Puerto',
                'Galpón 211',
                'Galpón 211 - Feria Artesanal',
                'Mimbrera',
            ],
            shopTypes: [
                { name: 'Entretenimientos', abbr: 'ENT' },
                { name: 'Bazar / Varios', abbr: 'BAZ' },
                { name: 'Decoración', abbr: 'DEC' },
                { name: 'Frutos del Delta', abbr: 'FRU' },
                { name: 'Gastronomía', abbr: 'GAS' },
                { name: 'Iluminación', abbr: 'ILU' },
                { name: 'Indumentaria', abbr: 'IND' },
                { name: 'Jardín', abbr: 'JAR' },
                { name: 'Muebles', abbr: 'MUB' },
                { name: 'Regionales', abbr: 'REG' },
            ],
            visibilities: [
                'Visible',
                'Oculto',
            ],
        }
    },
    methods: {
        searchOwner () {
            let prevTerm = this.searchTerms.owner;
            let placeholder = (this.searchTerms.owner != null) ? this.searchTerms.owner : '';
            this.searchTerms.owner = prompt("Filtro", placeholder);
            if (this.searchTerms.owner != prevTerm) {
                this.reloadList();
            }
        },
        clearOwnerFilter () {
            this.searchTerms.owner = null;
            this.reloadList();
        },
        searchName () {
            let prevTerm = this.searchTerms.name;
            let placeholder = (this.searchTerms.name != null) ? this.searchTerms.name : '';
            this.searchTerms.name = prompt("Filtro", placeholder);
            if (this.searchTerms.name != prevTerm) {
                this.reloadList();
            }
        },
        clearNameFilter () {
            this.searchTerms.name = null;
            this.reloadList();
        },
        searchSectorStart () {
            this.dialogSectorFilter = true;
        },
        searchSectorRun () {
            this.dialogSectorFilter = false;
            if (this.searchTerms.sector != null) {
                this.reloadList();
            }
        },
        clearSectorFilter () {
            this.searchTerms.sector = null;
            this.reloadList();
        },
        searchNumber () {
            let prevTerm = this.searchTerms.number;
            let placeholder = (this.searchTerms.number != null) ? this.searchTerms.number : '';
            this.searchTerms.number = prompt("Filtro", placeholder);
            if (this.searchTerms.number != prevTerm) {
                this.reloadList();
            }
        },
        clearNumberFilter () {
            this.searchTerms.number = null;
            this.reloadList();
        },
        searchVisibilityStart () {
            this.dialogVisibilityFilter = true;
        },
        searchVisibilityRun () {
            this.dialogVisibilityFilter = false;
            if (this.searchTerms.visible != null) {
                this.reloadList();
            }
        },
        clearVisibilityFilter () {
            this.searchTerms.visible = null;
            this.reloadList();
        },
        updateMarkerPosition () 
        {
            var p = this.$refs.mapMarker;
            this.lat = p.$markerObject.position.lat();
            this.lng = p.$markerObject.position.lng();
        },
        reloadList () {
            this.shops = [];
            this.lastListDoc = null;
            this.getShops();
        },
        getShops (auto) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;
            var query = db.collection("shops");
            var hasSortableFilter = false;

            if (this.searchTerms.owner != null) {
                console.log("this.searchTerms.owner", this.searchTerms.owner);
                query = query.where("owner", "==", this.searchTerms.owner);
            }
            if (this.searchTerms.name != null) {
                console.log("this.searchTerms.name", this.searchTerms.name);
                query = query.where("name", "==", this.searchTerms.name);
                hasSortableFilter = true;
            }
            if (this.searchTerms.sector != null) {
                console.log("this.searchTerms.sector", this.searchTerms.sector);
                query = query.where("sector", "==", this.searchTerms.sector);
                hasSortableFilter = true;
            }
            if (this.searchTerms.number != null) {
                console.log("this.searchTerms.number", this.searchTerms.number);
                query = query.where("number", "==", this.searchTerms.number);
            }
            if (this.searchTerms.visible != null) {
                console.log("this.searchTerms.visible", this.searchTerms.visible);
                query = query.where("visible", "==", (this.searchTerms.visible == 'Visible'));
            }

            if (!hasSortableFilter) {
                query = query.orderBy("name", "asc");
                query = query.orderBy("sector", "asc");
            }

            if (vm.lastListDoc) {
                console.log("lastListDoc exists, is a Nth page retrieval.");
                query = query.startAfter(vm.lastListDoc);
            }
            
            query = query.limit(10);

            console.log("query", query);

            query.get()
                .then(function(res) {
                    console.log("Received: " + res.docs.length);

                    res.forEach(doc => {
                        let item = doc.data();
                        item.id = doc.id;

                        if (!item.lat) item.lat = '-34.4199';
                        if (!item.lng) item.lng = '-58.5730';

                        vm.shops.push(item);

                        vm.lastListDoc = doc;
                    });

                    if (res.docs.length == 0 && auto !== true) {
                        alert("No hay más locales!");
                    }

                    loader.hide();
            })
            .catch(function(error) {
                console.error("Error getting shops list: ", error);
                loader.hide();
            });
        },
        addShop () {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;

            let item = {
                'owner': (vm.owner) ? vm.owner : '',
                'name': vm.name,
                'sector': vm.sector,
                'visible': vm.visible,
                'number': vm.number,
                'phone': vm.phone,
                'email': vm.email,
                'web': vm.web,
                'fb': vm.fb,
                'ig': vm.ig,
                'open': vm.open,
                'lat': vm.lat,
                'lng': vm.lng,
                'types': (vm.types) ? vm.types : [],
                'tags': (vm.tags) ? vm.tags : [],
            }

            if (!this.isEdition) {
                item.createdAt = new Date();

                db.collection('shops')
                    .add(item)
                    .then(function(obj) {
                        console.log(obj)
                        item.id = obj.id;
                        vm.shops.unshift(item);
                        vm.clearForm();
                        loader.hide();
                    })
                    .catch(function(err) {
                        console.log(err)
                        loader.hide();
                    });
            } else {
                item.modifiedAt = new Date();
                var itemRef = db.collection("shops").doc(this.itemID);

                itemRef
                    .update(item)
                    .then(function() {
                        console.log("Document successfully updated!");
                        
                        var idx = -1;
                        for (var i=0; i<vm.shops.length; i++) {
                            if (vm.itemID == vm.shops[i].id) {
                                idx = i;
                                break;
                            }
                        }

                        if (idx > -1) {
                            vm.shops[idx].owner = item.owner;
                            vm.shops[idx].name = item.name;
                            vm.shops[idx].sector = item.sector;
                            vm.shops[idx].visible = item.visible;
                            vm.shops[idx].number = item.number;
                            vm.shops[idx].phone = item.phone;
                            vm.shops[idx].email = item.email;
                            vm.shops[idx].web = item.web;
                            vm.shops[idx].fb = item.fb;
                            vm.shops[idx].ig = item.ig;
                            vm.shops[idx].open = item.open;
                            vm.shops[idx].lat = item.lat;
                            vm.shops[idx].lng = item.lng;
                            vm.shops[idx].types = item.types;
                            vm.shops[idx].tags = item.tags;
                        }
                        
                        vm.clearForm();
                        loader.hide();
                    })
                    .catch(function(error) {
                        console.error("Error updating document: ", error);
                        loader.hide();
                    });
            }
        },
        deleteShop (id) {
            if (confirm("Está seguro que quiere eliminar el local?")) {
                let loader = this.$loading.show(this.loaderPrefs);
                var vm = this;

                db.collection('shops').doc(id)
                    .delete()
                    .then(function() {
                        var idx = -1;
                        for (var i=0; i<vm.shops.length; i++) {
                            if (id == vm.shops[i].id) {
                                idx = i;
                                break;
                            }
                        }

                        if (idx > -1) {
                            vm.shops.splice(i, 1);
                        }

                        loader.hide();
                    })
                    .catch(function(error) {
                        console.error("Error deleting document: ", error);
                        loader.hide();
                    });
            }
        },
        removeTag (item) {
            this.tags.splice(this.tags.indexOf(item), 1)
            this.tags = [...this.tags]
        },
        startItemEdit (id) {
            var vm = this;
            vm.clearForm();

            var idx = -1;
            for (var i=0; i<vm.shops.length; i++) {
                if (id == vm.shops[i].id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                this.isEdition = true;
                this.itemID = vm.shops[idx].id;
                this.owner = vm.shops[idx].owner;
                this.name = vm.shops[idx].name;
                this.sector = vm.shops[idx].sector;
                this.visible = vm.shops[idx].visible;
                this.number = vm.shops[idx].number;
                this.phone = vm.shops[idx].phone;
                this.email = vm.shops[idx].email;
                this.web = vm.shops[idx].web;
                this.fb = vm.shops[idx].fb;
                this.ig = vm.shops[idx].ig;

                if (vm.shops[idx].open) {
                    this.open = vm.shops[idx].open;
                }

                this.lat = vm.shops[idx].lat;
                this.lng = vm.shops[idx].lng;
                this.types = vm.shops[idx].types;
                this.tags = vm.shops[idx].tags;
            }

            this.dialog = true;
        },
        clearForm () {
            this.dialog = false;

            // Clear values
            this.isEdition = false
            this.itemID = ''
            this.owner = ''
            this.name = ''
            this.sector = ''
            this.visible = false
            this.number = ''
            this.phone = ''
            this.email = ''
            this.web = ''
            this.fb = ''
            this.ig = ''
            this.open = {
                mon: '',
                tue: '',
                wed: '',
                thu: '',
                fri: '',
                sat: '',
                sun: '',
                hol: '',
            },
            this.lat = '-34.4199'
            this.lng = '-58.5730'
            this.types = []
            this.tags = []
        },
        gotoUsers () {
            this.$router.replace('users');
        },
        gotoNews () {
            this.$router.replace('news');
        },
        gotoComments () {
            this.$router.replace('comments');
        },
        gotoShops () {
            this.$router.replace('shops');
        },
        logout () {
            firebase.auth().signOut().then(() => {
                this.$router.replace('login')
            })
        },
        formatDate(d, format, fsep, msep, hsep) {
            if (!d) return "";

            if (!format) format = 'DD/MM/YYYY HH:MM'; 
            if (fsep === undefined) fsep = '/'; 
            if (msep === undefined) msep = ' '; 
            if (hsep === undefined) hsep = ':'; 

            let m = (d.getMonth() + 1);
            if (m < 10) {
                m = "0" + m;
            }

            let mi = d.getMinutes();
            if (mi < 10) {
                mi = "0" + mi;
            }

            if (format == 'YYYYMMDDHHMI') {
                return d.getFullYear() + fsep + m + fsep + d.getDate() + msep + d.getHours() + hsep + mi;
            } else {
                return d.getDate() + fsep + m + fsep + d.getFullYear() + msep + d.getHours() + hsep + mi;
            }
        }
    },
    mounted: function () {
        var vm = this;
        this.$nextTick(function () {
            vm.getShops(true);
        })
    }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: black;
}
input, button {
  margin-bottom: 10px;
}
.formLabel {
  font-size: 12px;
  font-weight: bold;
}
.button_blue {
  background-color: rgb(158, 206, 255);
}
.button_green {
  background-color: rgb(140, 231, 178);
}
.button_red {
  background-color: rgb(255, 154, 154);
}
.logout {
  left: 50%;
  top: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Shops.vue